import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './procurementDetail.css';

/**
 * Sticky bar at the bottom of every procurement step. Left: what has been
 * saved (or why the step is read-only). Right: Back, optional draft save and
 * the step's main action, always in that order.
 */
const StepActionBar = ({ status, statusTone, statusIcon, children }) => (
  <div className='pd-actionbar d-print-none'>
    <span
      className={classnames('pd-actionbar__status', {
        'is-ok': statusTone === 'ok',
        'is-warn': statusTone === 'warn',
      })}
    >
      {statusIcon && <i className={statusIcon} aria-hidden='true' />}
      {status}
    </span>
    {children}
  </div>
);

StepActionBar.propTypes = {
  status: PropTypes.node,
  statusTone: PropTypes.oneOf(['ok', 'warn', 'muted']),
  statusIcon: PropTypes.string,
  children: PropTypes.node,
};

export default StepActionBar;
